/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IHttpService, ILogService, IPromise, IQService} from 'angular';
import {TSRole} from '../../models/enums/TSRole';
import TSAnlaufstelle from '../../models/TSAnlaufstelle';
import TSAnlaufstelleWithUsers from '../../models/TSAnlaufstelleWithUsers';
import TSBenutzer from '../../models/TSBenutzer';
import IRequestShortcutConfig = angular.IRequestShortcutConfig;
import IRootScopeService = angular.IRootScopeService;

/**
 * Service zum verwalten von Anlaufstellen.
 */
export default class AnlaufstelleRS {

    static $inject = ['$http', 'CONSTANTS', '$q', '$rootScope', '$log'];

    /* @ngInject */
    constructor(private $http: IHttpService, private CONSTANTS: any, private $q: IQService,
                private $rootScope: IRootScopeService, private $log: ILogService) {
    }

    public getAllAnlaufstellen(): IPromise<Array<TSAnlaufstelle>> {
        return this.$http.get(this.CONSTANTS.REST_API + 'anlaufstellen/')
            .then((response) => {
                if (response.data !== undefined) {
                    this.$log.debug('PARSING Anlaufstellen REST  object', response.data);
                    return TSAnlaufstelle.deserializeArray(response.data);
                } else {
                    return [];
                }
            })
    }

    public getBenutzerOfAnlaufstelle(anlaufstelleId: string, roleToLimitTo?: TSRole): IPromise<Array<TSBenutzer>> {
        let configObject: IRequestShortcutConfig;
        if (roleToLimitTo === undefined) {
            configObject = {
                params: {
                    rolesToLimitTo: [TSRole[TSRole.ANLAUFSTELLE_SCHAETZER], TSRole[TSRole.ANLAUFSTELLE_SACHBEARBEITER]]
                }
            }
        } else {
            configObject = {
                params: {
                    rolesToLimitTo: [TSRole[roleToLimitTo]]
                }
            }
        }
        return this.$http.get(this.CONSTANTS.REST_API + 'anlaufstellen/' + encodeURIComponent(anlaufstelleId) + '/benutzer',
            configObject)
            .then((response) => {
                if (response.data !== undefined) {
                    this.$log.debug('PARSING Benutzer REST  object', response.data);
                    return TSBenutzer.deserializeArray(response.data);
                } else {
                    return [];
                }
            })
    }

    public findAnlaufstelle(anlaufstelleId: string): IPromise<TSAnlaufstelle | undefined> {
        return this.$http.get(this.CONSTANTS.REST_API + 'anlaufstellen/' + encodeURIComponent(anlaufstelleId))
            .then((response) => {
                if (response.data !== undefined) {
                    this.$log.debug('PARSING TSAnlaufstelle REST  object', response.data);
                    return new TSAnlaufstelle().deserialize(response.data);
                } else {
                    return undefined;
                }
            })

    }

    public findAnlaufstelleWithUsers(anlaufstelleId: string): IPromise<TSAnlaufstelle | undefined> {
        return this.$http.get(this.CONSTANTS.REST_API + 'anlaufstellen/' + encodeURIComponent(anlaufstelleId) + '/full')
            .then((response) => {
                if (response.data !== undefined) {
                    this.$log.debug('PARSING TSAnlaufstelleWithUsers REST  object', response.data);
                    return new TSAnlaufstelleWithUsers().deserialize(response.data);
                } else {
                    return undefined;
                }
            })

    }

    public createOrUpdate(anlaufstelle: TSAnlaufstelleWithUsers): IPromise<TSAnlaufstelle | undefined> {

        if (anlaufstelle) {
            let restAnlaufstelle: any = anlaufstelle.serialize({});
            return this.$http.put(this.CONSTANTS.REST_API + 'anlaufstellen/', restAnlaufstelle)
                .then((response) => {
                    if (response.data !== undefined) {
                        return new TSAnlaufstelleWithUsers().deserialize(response.data);
                    } else {
                        return undefined;
                    }
                });
        }
        this.$log.error('passed no data, no createOrUpdate request sent');
        return this.$q.when(undefined);

    }

    public createAnlaufstelleRegistration(anlaufstelle: TSAnlaufstelleWithUsers): IPromise<TSAnlaufstelle | undefined> {
        if (anlaufstelle) {
            let restAnlaufstelle: any = anlaufstelle.serialize({});
            return this.$http.post(this.CONSTANTS.REST_API + 'anlaufstellen/public/registration', restAnlaufstelle)
                .then((response) => {
                    if (response.data !== undefined) {
                        return new TSAnlaufstelleWithUsers().deserialize(response.data);
                    } else {
                        return undefined;
                    }
                });

        }
        this.$log.error('passed no data, no reset request sent');
        return this.$q.when(undefined);
    }

    public readAnlaufstellenSuggestion(searchString: string): IPromise<Array<TSAnlaufstelle>> {
        return this.$http.get(this.CONSTANTS.REST_API + 'anlaufstellen/search/',
            {
                params: {
                    queryString: searchString,
                }
            })
            .then((response) => {
                if (response.data !== undefined) {
                    this.$log.debug('PARSING Anlaufstellen REST  object', response.data);
                    return TSAnlaufstelle.deserializeArray(response.data);
                } else {
                    return [];
                }
            })
    }

}



// WEBPACK FOOTER //
// ./src/app/core/service/AnlaufstelleRS.rest.ts